module.exports = __webpack_public_path__ + "static/media/6ix.330e3645.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/6ix.gif
// module id = 478
// module chunks = 0